// 预设翻译字典:计划文案的常规语言初稿。语言切换器列出的是 Shopify 店铺
// 的 published locale(见 /api/locales),而这里的预设覆盖最常见的那十来
// 种——切到预设语言时表单立刻填好对应文案(按计划类型),商户可直接微调
// 后保存;店铺语言不在预设里时表单留空,c 端渲染回退到默认语言(英语)。
//
// 结构:locale → { footerText, types: { <planType>: { displayName,
// description, disabledDescription } } }。locale 键一律用基础码('zh' 而
// 非 'zh-CN'),查找时由 presetForLocale 做前缀归一。
export const PRESET_LANGUAGE_NAMES = {
  zh: '中文',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  pt: 'Português',
  it: 'Italiano',
  nl: 'Nederlands',
  ru: 'Русский',
  ja: '日本語',
  ko: '한국어',
  ar: 'العربية',
  tr: 'Türkçe'
};

export const PRESET_TRANSLATIONS = {
  zh: {
    footerText: '查看条款',
    types: {
      shipping_protection: {
        displayName: '运费保护',
        description: '保障您的订单在运输途中不丢失、不受损、不被盗。',
        disabledDescription: '不了,谢谢,我不需要运费保护。'
      },
      warranty: {
        displayName: '延长保修',
        description: '承保制造缺陷与正常磨损,保修 2 年。',
        disabledDescription: '不了,谢谢,我不需要延长保修。'
      },
      return_insurance: {
        displayName: '退货保障',
        description: '14 天内退回任意商品,全额退款,无需理由。',
        disabledDescription: '不了,谢谢,我不需要退货保障。'
      },
      custom: {
        displayName: '保护计划',
        description: '为您的订单添加保障。',
        disabledDescription: '不了,谢谢,我不需要保护计划。'
      }
    }
  },
  es: {
    footerText: 'Ver términos',
    types: {
      shipping_protection: {
        displayName: 'Protección de envío',
        description: 'Protege tu pedido contra pérdida, daños o robo durante el envío.',
        disabledDescription: 'No, gracias — no necesito protección de envío.'
      },
      warranty: {
        displayName: 'Garantía extendida',
        description: 'Cubre defectos de fabricación y desgaste normal durante 2 años.',
        disabledDescription: 'No, gracias — no necesito la garantía extendida.'
      },
      return_insurance: {
        displayName: 'Seguro de devolución',
        description: 'Devuelve cualquier artículo dentro de 14 días y recibe un reembolso completo.',
        disabledDescription: 'No, gracias — no necesito el seguro de devolución.'
      },
      custom: {
        displayName: 'Plan de protección',
        description: 'Añade protección a tu pedido.',
        disabledDescription: 'No, gracias — no necesito el plan de protección.'
      }
    }
  },
  fr: {
    footerText: 'Voir les conditions',
    types: {
      shipping_protection: {
        displayName: "Protection d'expédition",
        description: "Protégez votre commande contre la perte, les dommages et le vol pendant l'expédition.",
        disabledDescription: "Non merci — je n'ai pas besoin de la protection d'expédition."
      },
      warranty: {
        displayName: 'Garantie étendue',
        description: "Couvre les défauts de fabrication et l'usure normale pendant 2 ans.",
        disabledDescription: "Non merci — je n'ai pas besoin de la garantie étendue."
      },
      return_insurance: {
        displayName: 'Assurance retour',
        description: 'Retournez tout article sous 14 jours pour un remboursement complet.',
        disabledDescription: "Non merci — je n'ai pas besoin de l'assurance retour."
      },
      custom: {
        displayName: 'Plan de protection',
        description: 'Ajoutez une protection à votre commande.',
        disabledDescription: "Non merci — je n'ai pas besoin du plan de protection."
      }
    }
  },
  de: {
    footerText: 'Bedingungen ansehen',
    types: {
      shipping_protection: {
        displayName: 'Versandversicherung',
        description: 'Schützt Ihre Bestellung vor Verlust, Beschädigung und Diebstahl beim Versand.',
        disabledDescription: 'Nein danke — ich brauche keine Versandversicherung.'
      },
      warranty: {
        displayName: 'Erweiterte Garantie',
        description: 'Deckt Fabrikationsfehler und normale Abnutzung für 2 Jahre ab.',
        disabledDescription: 'Nein danke — ich brauche keine erweiterte Garantie.'
      },
      return_insurance: {
        displayName: 'Rücksendeversicherung',
        description: 'Geben Sie Artikel innerhalb von 14 Tagen zurück — volle Rückerstattung.',
        disabledDescription: 'Nein danke — ich brauche keine Rücksendeversicherung.'
      },
      custom: {
        displayName: 'Schutzplan',
        description: 'Fügen Sie Ihrer Bestellung Schutz hinzu.',
        disabledDescription: 'Nein danke — ich brauche keinen Schutzplan.'
      }
    }
  },
  pt: {
    footerText: 'Ver termos',
    types: {
      shipping_protection: {
        displayName: 'Proteção de envio',
        description: 'Protege seu pedido contra perda, danos e roubo durante o envio.',
        disabledDescription: 'Não, obrigado — não preciso de proteção de envio.'
      },
      warranty: {
        displayName: 'Garantia estendida',
        description: 'Cobre defeitos de fabricação e desgaste normal por 2 anos.',
        disabledDescription: 'Não, obrigado — não preciso da garantia estendida.'
      },
      return_insurance: {
        displayName: 'Seguro de devolução',
        description: 'Devolva qualquer item em até 14 dias com reembolso total.',
        disabledDescription: 'Não, obrigado — não preciso do seguro de devolução.'
      },
      custom: {
        displayName: 'Plano de proteção',
        description: 'Adicione proteção ao seu pedido.',
        disabledDescription: 'Não, obrigado — não preciso do plano de proteção.'
      }
    }
  },
  it: {
    footerText: 'Vedi condizioni',
    types: {
      shipping_protection: {
        displayName: 'Protezione spedizione',
        description: 'Protegge il tuo ordine da perdita, danni e furti durante la spedizione.',
        disabledDescription: 'No grazie — non mi serve la protezione spedizione.'
      },
      warranty: {
        displayName: 'Garanzia estesa',
        description: 'Copre difetti di fabbricazione e usura normale per 2 anni.',
        disabledDescription: 'No grazie — non mi serve la garanzia estesa.'
      },
      return_insurance: {
        displayName: 'Assicurazione reso',
        description: 'Restituisci qualsiasi articolo entro 14 giorni per un rimborso completo.',
        disabledDescription: 'No grazie — non mi serve l’assicurazione reso.'
      },
      custom: {
        displayName: 'Piano di protezione',
        description: 'Aggiungi protezione al tuo ordine.',
        disabledDescription: 'No grazie — non mi serve il piano di protezione.'
      }
    }
  },
  nl: {
    footerText: 'Voorwaarden bekijken',
    types: {
      shipping_protection: {
        displayName: 'Verzendbescherming',
        description: 'Beschermt je bestelling tegen verlies, schade en diefstal tijdens verzending.',
        disabledDescription: 'Nee bedankt — ik heb geen verzendbescherming nodig.'
      },
      warranty: {
        displayName: 'Uitgebreide garantie',
        description: 'Dekt fabricagefouten en normale slijtage gedurende 2 jaar.',
        disabledDescription: 'Nee bedankt — ik heb geen uitgebreide garantie nodig.'
      },
      return_insurance: {
        displayName: 'Retourverzekering',
        description: 'Retourneer elk artikel binnen 14 dagen met volledige terugbetaling.',
        disabledDescription: 'Nee bedankt — ik heb geen retourverzekering nodig.'
      },
      custom: {
        displayName: 'Beschermingsplan',
        description: 'Voeg bescherming toe aan je bestelling.',
        disabledDescription: 'Nee bedankt — ik heb geen beschermingsplan nodig.'
      }
    }
  },
  ru: {
    footerText: 'Посмотреть условия',
    types: {
      shipping_protection: {
        displayName: 'Защита доставки',
        description: 'Защитите заказ от утери, повреждения и кражи при доставке.',
        disabledDescription: 'Нет, спасибо — защита доставки мне не нужна.'
      },
      warranty: {
        displayName: 'Расширенная гарантия',
        description: 'Покрывает производственные дефекты и естественный износ в течение 2 лет.',
        disabledDescription: 'Нет, спасибо — расширенная гарантия мне не нужна.'
      },
      return_insurance: {
        displayName: 'Страхование возврата',
        description: 'Возврат любого товара в течение 14 дней с полным возмещением.',
        disabledDescription: 'Нет, спасибо — страхование возврата мне не нужно.'
      },
      custom: {
        displayName: 'План защиты',
        description: 'Добавьте защиту к вашему заказу.',
        disabledDescription: 'Нет, спасибо — план защиты мне не нужен.'
      }
    }
  },
  ja: {
    footerText: '規約を見る',
    types: {
      shipping_protection: {
        displayName: '配送保護',
        description: '配送中の紛失・破損・盗難からご注文を保護します。',
        disabledDescription: 'いいえ、結構です。配送保護は不要です。'
      },
      warranty: {
        displayName: '延長保証',
        description: '2年間、製造上の欠陥と通常の摩耗を補償します。',
        disabledDescription: 'いいえ、結構です。延長保証は不要です。'
      },
      return_insurance: {
        displayName: '返品保険',
        description: '14日以内なら理由を問わず全額返金で返品できます。',
        disabledDescription: 'いいえ、結構です。返品保険は不要です。'
      },
      custom: {
        displayName: '保護プラン',
        description: 'ご注文に補償を追加します。',
        disabledDescription: 'いいえ、結構です。保護プランは不要です。'
      }
    }
  },
  ko: {
    footerText: '약관 보기',
    types: {
      shipping_protection: {
        displayName: '배송 보호',
        description: '배송 중 분실, 파손, 도난으로부터 주문을 보호합니다.',
        disabledDescription: '아니요, 괜찮습니다. 배송 보호는 필요 없습니다.'
      },
      warranty: {
        displayName: '연장 보증',
        description: '2년 동안 제조 결함 및 정상적인 마모를 보장합니다.',
        disabledDescription: '아니요, 괜찮습니다. 연장 보증은 필요 없습니다.'
      },
      return_insurance: {
        displayName: '반품 보험',
        description: '14일 이내에 상품을 반품하면 전액 환불됩니다.',
        disabledDescription: '아니요, 괜찮습니다. 반품 보험은 필요 없습니다.'
      },
      custom: {
        displayName: '보호 플랜',
        description: '주문에 보호를 추가하세요.',
        disabledDescription: '아니요, 괜찮습니다. 보호 플랜은 필요 없습니다.'
      }
    }
  },
  ar: {
    footerText: 'عرض الشروط',
    types: {
      shipping_protection: {
        displayName: 'حماية الشحن',
        description: 'تحمي طلبك من الفقدان والتلف والسرقة أثناء الشحن.',
        disabledDescription: 'لا شكرًا — لا أحتاج إلى حماية الشحن.'
      },
      warranty: {
        displayName: 'ضمان ممتد',
        description: 'يغطي عيوب التصنيع والتآكل الطبيعي لمدة عامين.',
        disabledDescription: 'لا شكرًا — لا أحتاج إلى الضمان الممتد.'
      },
      return_insurance: {
        displayName: 'تأمين الإرجاع',
        description: 'أرجع أي منتج خلال 14 يومًا واسترد كامل المبلغ.',
        disabledDescription: 'لا شكرًا — لا أحتاج إلى تأمين الإرجاع.'
      },
      custom: {
        displayName: 'خطة الحماية',
        description: 'أضف الحماية إلى طلبك.',
        disabledDescription: 'لا شكرًا — لا أحتاج إلى خطة الحماية.'
      }
    }
  },
  tr: {
    footerText: 'Koşulları görüntüle',
    types: {
      shipping_protection: {
        displayName: 'Kargo koruması',
        description: 'Siparişinizi kargo sırasında kayıp, hasar ve hırsızlığa karşı korur.',
        disabledDescription: 'Hayır, teşekkürler — kargo koruması istemiyorum.'
      },
      warranty: {
        displayName: 'Uzatılmış garanti',
        description: '2 yıl boyunca üretim hatalarını ve normal aşınmayı kapsar.',
        disabledDescription: 'Hayır, teşekkürler — uzatılmış garanti istemiyorum.'
      },
      return_insurance: {
        displayName: 'İade sigortası',
        description: '14 gün içinde her ürünü tam iade ile geri gönderin.',
        disabledDescription: 'Hayır, teşekkürler — iade sigortası istemiyorum.'
      },
      custom: {
        displayName: 'Koruma planı',
        description: 'Siparişinize koruma ekleyin.',
        disabledDescription: 'Hayır, teşekkürler — koruma planı istemiyorum.'
      }
    }
  }
};

// lookupPreset 找到 locale 对应的预设:完整码优先('zh-cn'),再取语言
// 基础码('zh'),都没有就返回 null(非预设语言)。
function lookupPreset(locale) {
  if (!locale) return null;
  const lc = String(locale).toLowerCase();
  if (PRESET_TRANSLATIONS[lc]) return PRESET_TRANSLATIONS[lc];
  return PRESET_TRANSLATIONS[lc.split('-')[0]] || null;
}

// presetForLocale 返回某语言在给定计划类型下的预设译文(displayName /
// description / disabledDescription / footerText)。返回 null 表示该语言
// 没有预设——表单保持留空,c 端回退到默认语言(英语)内容。
export function presetForLocale(locale, planType) {
  const preset = lookupPreset(locale);
  if (!preset) return null;
  const fields = preset.types[planType] || preset.types.custom;
  return { ...fields, footerText: preset.footerText };
}

// hasPreset 该语言是否在预设里(决定表单 helpText 的回退提示)。
export function hasPreset(locale) {
  return lookupPreset(locale) != null;
}
